import store from 'store2'
import $ from 'jquery';

export default function(file,format,start,done){

  var video = null
  var tries = null
  var loads = 0

  var startTime = new Date()

  var ombStore = store.namespace('omb')

  var server = Config.server.video

  if(ombStore('role') == 'admin' || ombStore('role') == 'author'){
    var src = `${server}stream/archive/${format}/${file}`
  } else {
    var src = `${server}stream/watermark/${format}/${file}`.replace('.mp4','_wm.mp4')
  }

  var init = function(){
    tries = 0
    loads++
    video =
      $('<video>').attr({
        src: src,
        controls: false,
        muted: true,
        playsinline: true,
        width: 640,
        height: 480,
        preload: 'none',

      })
    video[0].load()
    // video[0].playbackRate = 0.5
    // this.play()
    // this.pause()
    // this.play()
    interval()
  }

  var interval = function(){
    requestAnimationFrame(function(){

      if(video[0].currentTime != start){
        video[0].currentTime = start
      }

      if(++tries > 50){
        init()
        return
      }

      if(_.round(video[0].currentTime,1) != video[0].currentTime){
        start += 0.1;
      }

      // console.log('preparing',file,'start',start,'tries',tries,'loads',loads,'state',video[0].readyState,'time',video[0].currentTime,'video',video[0])

      if(video[0].readyState > 3){
        var completedTime = new Date()
        var duration = completedTime - startTime
        done(null, video[0], duration)
        // console.log('duration',duration)
        // console.log('prepared',file,'tries',tries,'loads',loads)

      } else {
        setTimeout(function(){
          interval()
        }, 100)
      }

    })
  }

  init()

}



// WEBPACK FOOTER //
// ./src/client/lib/prepare.js